import { dayLabel } from '../constants/time';

export const serializeParams = (isNew = false, schedule = {}) => {
  const daysArr = Array.from({ length: 7 }, (_, i) => i);
  if (isNew) {
    return daysArr.reduce((acc, day) => {
      acc[day] = {
        start: '09:00',
        end: '18:00',
        disabled: day === 0 || day === 6 ? true : false,
        id: day,
        label: dayLabel[day],
      };
      return acc;
    }, {});
  }
  return daysArr.reduce((acc, day) => {
    if (!schedule[day]) {
      acc[day] = {
        start: '09:00',
        end: '18:00',
        disabled: true,
        id: day,
        label: dayLabel[day],
      };
    } else {
      acc[day] = {
        ...schedule[day],
        disabled: false,
        id: day,
        label: dayLabel[day],
      };
    }
    return acc;
  }, {});
};

export const deserializeParams = (schedule) => {
  return Object.values(schedule)
    .filter(({ disabled }) => !disabled)
    .reduce((acc, curr) => {
      const { id, start, end } = curr;
      acc[id] = { start, end };
      return acc;
    }, {});
};
